<template>
  <Button
    :size="size"
    :type="type === 'pseudo-link' ? 'pseudo-link' : ''"
    :additional-type="additionalType"
    :without-border="withoutBorder"
    class="add-comment-button"
    @click.native.stop="handleButton"
  >
    <svg v-if="isIcon"
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M2 15.5V3.5C2 2.67157 2.67157 2 3.5 2H14C14.8284 2 15.5 2.67157 15.5 3.5V11C15.5 11.8284 14.8284 12.5 14 12.5H6.5C6.17535 12.4994 5.85936 12.6047 5.6 12.8L2 15.5ZM3.5 3.5V12.5L5.1005 11.3C5.35973 11.1045 5.6758 10.9991 6.0005 11H14V3.5H3.5Z" fill="currentColor"/>
    </svg>
    {{ btnText }}
  </Button>
</template>

<script>
import { mapState } from 'vuex'
import Button from '../inputs/Button'

export default {
  name: 'AddCommentButton',
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    },
    postCommentEndpoint: {
      type: String,
      required: true
    },
    formType: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    additionalType: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium'
    },
    productId: {
      type: Number,
      default: null
    },
    products: {
      type: Array,
      default: null
    },
    isIcon: {
      type: Boolean,
      default: false
    },
    withoutBorder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Button
  },
  computed: {
    ...mapState({
      auth: state => state.user.auth
    }),
    btnText () {
      return this.isQuestions ? this.$t('questions.add_question') : this.$t('comment.button.add')
    }
  },
  methods: {
    handleButton () {
      if (!this.auth) return this.openAuthModal()
      else if (this.products && this.products.length > 1) return this.openSelectProductModal()

      this.$modal.hide('select-product-comment-modal')
      let productId = null
      if (this.productId) {
        productId = this.productId
      } else if (this.products && 'id' in this.products[0]) {
        productId = this.products[0].id
      }

      this.openCommentModal(productId)
    },
    openAuthModal () {
      this.$modal.show('auth-modal', {
        title: this.$t('comments_add_comment_auth_title')
      })
    },
    openSelectProductModal () {
      this.$modal.show('select-product-comment-modal', {
        endpoint: this.postCommentEndpoint,
        formType: this.formType,
        items: this.products
      })
    },
    openCommentModal (productId = null) {
      this.$modal.show('comment-modal', {
        endpoint: this.postCommentEndpoint,
        formType: this.formType,
        productId: productId,
        isQuestions: this.isQuestions
      })
    }
  }
}
</script>

<style scoped lang="sass">
.add-comment-button
  display: flex
  align-items: center

  svg
    margin-right: 10px
    flex-shrink: 0
</style>
